import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import React, { useCallback } from 'react';

import { Drawer } from '~/components/blocks';
import { newPatientDrawerState } from '~/state/patient/atoms';
import { NewPatientPanelMap } from '~/state/patient/types';

import { ConfirmNewPatientPanel } from './ConfirmNewPatientPanel';
import { InputNewPatientPanel } from './InputNewPatientPanel';
import { QrCodeReaderDialog } from './QrCodeReaderDialog';

export const NewPatientDrawer = () => {
  const { isOpen, currentPanel } = useAtomValue(newPatientDrawerState);
  const resetState = useResetAtom(newPatientDrawerState);

  const handleClose = useCallback(() => resetState(), [resetState]);

  return (
    <>
      <Drawer open={isOpen} onClose={handleClose}>
        {currentPanel === NewPatientPanelMap.input && <InputNewPatientPanel />}
        {currentPanel === NewPatientPanelMap.confirm && <ConfirmNewPatientPanel />}
      </Drawer>
      <QrCodeReaderDialog />
    </>
  );
};
